(function () {
  function formatMoney(cents) {
    if (window.theme && window.theme.Currency && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.theme.Currency.formatMoney(cents, window.theme.settings.moneyFormat);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function update(cart) {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    Array.prototype.forEach.call(bars, function (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10);
      if (!threshold || isNaN(threshold)) return;

      var current = cart.total_price;
      var remaining = Math.max(threshold - current, 0);
      var percent = Math.min((current / threshold) * 100, 100);
      var reached = current >= threshold;

      var fill = bar.querySelector('[data-free-shipping-fill]');
      var text = bar.querySelector('[data-free-shipping-text]');

      if (fill) fill.style.width = percent + '%';
      bar.classList.toggle('is-reached', reached);

      if (text) {
        if (reached) {
          text.innerHTML = '🎉 Du hast den kostenlosen Versand erreicht!';
        } else {
          text.innerHTML = 'Nur noch <strong>' + formatMoney(remaining) + '</strong> bis zum kostenlosen Versand!';
        }
      }
    });
  }

  // Warenkorb selbst nachladen, wenn das Ereignis keinen mitbringt.
  function refresh() {
    var url = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(update)
      .catch(function () {});
  }

  // Mengenaenderung im Warenkorb: Motion liefert den Warenkorb mit.
  document.addEventListener('cart:updated', function (e) {
    if (e && e.detail && e.detail.cart) update(e.detail.cart);
    else refresh();
  });

  // Quick-Add und Upsell-Karten feuern NUR 'ajaxProduct:added', und zwar ohne
  // Warenkorb im detail. Ohne diese Zeile bleibt die Leiste auf dem Stand vom
  // Seitenaufruf stehen.
  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('cart:build', refresh);
})();
